import React, { useState, useEffect } from "react";

const MinimalDigitalLoading = () => {
  const [progress, setProgress] = useState(0);
  const [blinking, setBlinking] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1;
      });
    }, 50);

    const blinkInterval = setInterval(() => {
      setBlinking(prev => !prev);
    }, 500);

    return () => {
      clearInterval(interval);
      clearInterval(blinkInterval);
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-black flex flex-col items-center justify-center z-50">
      
      {/* Digital display effect */}
      <div className="relative font-mono">
        
        {/* LOADING text */}
        <div className="text-3xl text-gray-300 mb-8 tracking-widest">
          LOADING{blinking ? '_' : ''}
        </div>
        
        {/* Percentage with digital effect */}
        <div className="relative">
          <div className="text-7xl font-bold text-green-400 mb-2">
            {progress.toString().padStart(3, '0')}
            <span className="text-green-300">%</span>
          </div>
          
          {/* Progress bar */}
          <div className="w-64 h-1 bg-gray-800 overflow-hidden">
            <div 
              className="h-full bg-green-400 transition-all duration-200"
              style={{ width: `${progress}%` }}
            >
              {/* Scan line */}
              <div className="absolute right-0 top-0 bottom-0 w-1 bg-white animate-pulse"></div>
            </div>
          </div>
          
          {/* Progress dots */}
          <div className="flex justify-between mt-2 text-xs text-gray-500">
            <div className={progress >= 0 ? 'text-green-400' : ''}>0%</div>
            <div className={progress >= 25 ? 'text-green-400' : ''}>25%</div>
            <div className={progress >= 50 ? 'text-green-400' : ''}>50%</div>
            <div className={progress >= 75 ? 'text-green-400' : ''}>75%</div>
            <div className={progress >= 100 ? 'text-green-400' : ''}>100%</div>
          </div>
        </div>
        
        {/* Status line */}
        <div className="mt-8 text-sm text-gray-500">
          <span className={blinking ? 'text-green-400' : ''}>█</span>
          <span> SYSTEM READY</span>
        </div>
      </div>
      
      {/* Social indicators */}
      <div className="absolute bottom-8 text-gray-600 text-sm">
        LinkedIn • GitHub • Twitter
      </div>
    </div>
  );
};

export default MinimalDigitalLoading;